import { useLayoutEffect, useRef } from "react";
import { useAppDispatch } from "../store";
import { updateVideoPosition } from "../store/slices/modalsSlice";
import { useRect } from "@reach/rect";
import { twMerge } from "tailwind-merge";

export function VideoPlaceholder({
  className,
}: React.ComponentPropsWithoutRef<"div">) {
  const ref = useRef(null);
  const dispatch = useAppDispatch();

  useRect(ref, {
    onChange(rect) {
      dispatch(
        updateVideoPosition({
          x: rect.left,
          y: rect.top,
          width: rect.width,
          height: rect.height,
        })
      );
    },
  });

  useLayoutEffect(() => {
    return () => {
      dispatch(
        updateVideoPosition({
          x: 0,
          y: 0,
          width: 0,
          height: 0,
        })
      );
    };
  }, []);

  return (
    <div
      ref={ref}
      id="video-placeholder"
      className={twMerge([
        "relative h-[calc(100vh-550px)] text-gray-300 flex justify-center items-center xl:max-h-[180px] aspect-video border rounded-lg border-dashed border-gray-300",
        className,
      ])}
    >
      Placeholder for video
    </div>
  );
}
